import { useSSOContextStore } from "@faire/retailer-visitor-shared/stores/domain/SSO/SSOContextStore";
import { useCallback } from "react";

// ts-prune-ignore-next will use in followup PR
export const useSSOPasswordStore = () => {
  const [{ userHasPassword, showConfirmPasswordView }, setStore] =
    useSSOContextStore(["userHasPassword", "showConfirmPasswordView"]);

  const setUserHasPassword = useCallback(
    (userHasPassword: boolean) => {
      setStore({
        userHasPassword,
      });
    },
    [setStore]
  );

  const setShowConfirmPasswordView = useCallback(
    (showConfirmPasswordView: boolean) => {
      setStore({
        showConfirmPasswordView,
      });
    },
    [setStore]
  );

  return {
    userHasPassword,
    showConfirmPasswordView,
    setUserHasPassword,
    setShowConfirmPasswordView,
  };
};
